import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { tap } from 'rxjs/operators';
import { ImmersionCourseService } from '../immersion-course.service';
import { LessonPlayerService } from '../lesson-player.service';
import { OeAppService } from '../oe-app.service';
import { StudyBundleCourseDto } from '../types/StudyBundleCourseDto';
import { PlayerViewerType } from '../types/player-viewer-type.enum';
import { ActivityPlayerEvent } from './activity-player-event.enum';

@Component({
  selector: 'lp2-activity-player',
  templateUrl: './activity-player.component.html',
  styleUrls: ['./activity-player.component.scss'],
})
export class ActivityPlayerComponent implements OnInit, OnDestroy {
  @Input() course: StudyBundleCourseDto;
  @Input() complete = false;
  @Output() started = new EventEmitter();
  @Output() completeChange = new EventEmitter<boolean>();
  @Output() close = new EventEmitter();
  @ViewChild('iframe') iframe: ElementRef;
  activityUrl: SafeUrl;

  constructor(
    private readonly oeApp: OeAppService,
    private readonly immersionCourseService: ImmersionCourseService,
    private readonly lessonPlayerService: LessonPlayerService
  ) {
    this.handlePlayerEvents = this.handlePlayerEvents.bind(this);
    this.toggleIndex = this.toggleIndex.bind(this);
  }

  ngOnInit() {
    if (!this.course) {
      return;
    }

    if (this.complete) {
      this.setActivityUrl$().subscribe(() => {
        this.started.emit();
      });
    } else {
      this.immersionCourseService.retrieveBookmark(this.course.id).subscribe((userBookmark) => {
        this.setActivityUrl$(userBookmark).subscribe(() => {
          this.started.emit();
        });
      });
    }

    window.addEventListener('message', this.handlePlayerEvents, false);
  }

  setActivityUrl$(bookmark = 0) {
    const lessonId = this.course && this.course.mediaData;
    if (lessonId) {
      return this.lessonPlayerService
        .getActivityUrl$(lessonId, PlayerViewerType.ISC, false, bookmark)
        .pipe(tap((activityurl) => (this.activityUrl = activityurl)));
    }
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handlePlayerEvents);
  }

  updateBookmark(contentId: number, slideIndex: number) {
    this.immersionCourseService.saveBookmark(contentId, slideIndex).subscribe();
  }

  toggleIndex() {
    this.iframe.nativeElement.contentWindow.postMessage('toggleIndex', '*');
  }

  handlePlayerEvents({ data, origin }) {
    if (origin !== this.oeApp.activityPlayerHost()) {
      return;
    }

    if (!data || !data.type) {
      return;
    }

    const type: ActivityPlayerEvent = data.type;

    switch (type) {
      case ActivityPlayerEvent.ACTIVITY_COMPLETE:
        this.updateBookmark(this.course.id, data.index + 1);
        break;
      case ActivityPlayerEvent.LESSON_COMPLETE:
        this.completeChange.emit(true);
        break;
      case ActivityPlayerEvent.FINISH_LESSON:
        this.close.emit();
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/activity-player/activity-player.component.ts